import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SpiSharedModule } from '../shared/spi.shared.module';

import { menu } from './menu';
import { routes } from './routes';
import {MenuService} from '../core/menu/menu.service';

@NgModule({
  imports: [
    SpiSharedModule,
    RouterModule.forRoot(routes)
  ],
  declarations: [],
  exports: [
    RouterModule
  ]
})

export class RoutesModule {
  constructor(public menuService: MenuService) {
    menuService.addMenu(menu);
  }
}
